// FormModal.jsx
import React, {useState, useEffect, useCallback} from 'react';
import { Modal } from 'react-bootstrap';
import { BorrowerLeadGenerationTool } from 'borrower-lead-generation-tool';
import './FormModal.css';

const FormModal = ({ show, onHide, loanType, workflowUrl }) => {

    const [node, setNode] = useState(null);
    // watches for changes in the form.
    const formRef = useCallback((node) => {
        // node refers to the name input field in the BorrowerLeadGenerationTool
        setNode(node);
      }, []);
      useEffect(() => {
        const handleButtonClick = (e) => {
          if (e.target && e.target.classList.contains('btn-success')) {
    
          }
        };
    
        document.addEventListener('click', handleButtonClick);
    
        return () => {
          document.removeEventListener('click', handleButtonClick);
        };
      }, []); 
    return (
        <Modal size="lg" centered show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Please fill the information below to continue</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <BorrowerLeadGenerationTool
                    // showCustomizeLOApplyNowUrl
                    // showTruApprovalButton={false}
                    // showModalBackBtn={false}
                    leadSource="NET007"
                    loanOfficerUid="DAVE"
                    webPageURL={process.env.REACT_APP_STATE_DOMAIN}
                    statesDomain={process.env.REACT_APP_STATE_DOMAIN}
                    domainNameConsent="lowrates.com"
                    language="en"
                    continueBtnRedirectUrl={loanType}
                    workflowUrl={workflowUrl}
                    mainBtnName="Apply Now"
                />
            </Modal.Body>
        </Modal>
    );
};

export default FormModal;